import CustomerMapOverlay from './CustomerMapOverlay';

export default CustomerMapOverlay;
